<div *ngIf="selectedCard" class="card-preview-container">
  <div class="preview-header">
    <mat-icon
      class="material-symbols-outlined icon-display"
    >
      manage_search
    </mat-icon>
    Vergrößerte Vorschau</div>
  <div class="card-preview">
    <div class="arrow-left"></div>
    <em-pattern-card
      [cardPatternId]="selectedCard.id"
      [cardDeckId]="selectedCard.cardDeckId"
      [cardDeckType]="selectedCard.cardDeckType"
      [rightSidenav]="rightSidenav"
      [showSelectToggle]="true"
    ></em-pattern-card>
  </div>
</div>
